import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRightIcon, CalendarIcon } from 'lucide-react';
const events = [{
  title: 'Grand Opening: Malgudi Filmy',
  date: 'Oct 15, 2025',
  description: 'Join us for the grand opening of our newest cinematic dining experience.',
  image: 'https://images.pexels.com/photos/1190298/pexels-photo-1190298.jpeg?auto=compress&cs=tinysrgb&w=800'
}, {
  title: 'Diwali Special Menu',
  date: 'Nov 1-5, 2025',
  description: 'Celebrate the festival of lights with our exclusive festive tasting menu.',
  image: 'https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&w=800'
}, {
  title: 'Live Music Fridays at Saffron',
  date: 'Every Friday',
  description: 'Enjoy soulful live performances accompanied by signature cocktails.',
  image: 'https://images.pexels.com/photos/167491/pexels-photo-167491.jpeg?auto=compress&cs=tinysrgb&w=800'
}, {
  title: 'Sunday Brunch Buffet',
  date: 'Every Sunday',
  description: 'An lavish spread of Indian and International delicacies at Royal Bengal Tigers.',
  image: 'https://images.pexels.com/photos/2291367/pexels-photo-2291367.jpeg?auto=compress&cs=tinysrgb&w=800'
}, {
  title: "New Year's Eve Gala",
  date: 'Dec 31, 2025',
  description: 'Ring in the new year with a spectacular gala dinner and entertainment.',
  image: 'https://images.pexels.com/photos/3171837/pexels-photo-3171837.jpeg?auto=compress&cs=tinysrgb&w=800'
}];
export function EventsPromotions() {
  const scrollRef = useRef<HTMLDivElement>(null);
  return <section className="bg-[#f2f2f4] py-24 md:py-32 px-6 overflow-hidden" data-id="element-73">
      <div className="max-w-7xl mx-auto" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-75">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-76">
            Happenings
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6" data-id="element-77">
            Events & Offers
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-78" />
          <p className="text-[#86868b] text-[18px] max-w-2xl mx-auto font-light" data-id="element-79">
            Discover what's happening across our venues
          </p>
        </motion.div>

        <div ref={scrollRef} className="flex overflow-x-auto gap-8 pb-12 snap-x snap-mandatory scrollbar-hide -mx-6 px-6 md:mx-0 md:px-0" data-id="element-80">
          {events.map((event, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex-shrink-0 w-[300px] md:w-[350px] snap-center group cursor-pointer" data-id="element-81">
              <div className="relative h-[400px] rounded-sm overflow-hidden mb-6" data-id="element-82">
                <img src={event.image} alt={event.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-83" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500" data-id="element-84" />

                <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-85">
                  <div className="flex items-center gap-2 text-[#c9a961] text-[13px] font-bold uppercase tracking-wider mb-3" data-id="element-86">
                    <CalendarIcon className="w-4 h-4" data-id="element-87" />
                    {event.date}
                  </div>
                  <h3 className="font-display text-[24px] text-white mb-3 leading-tight group-hover:text-[#c9a961] transition-colors" data-id="element-88">
                    {event.title}
                  </h3>
                  <p className="text-white/70 text-[15px] font-light leading-relaxed mb-6 line-clamp-3" data-id="element-89">
                    {event.description}
                  </p>
                  <span className="inline-flex items-center gap-2 text-white text-[13px] font-bold uppercase tracking-wider group-hover:gap-3 transition-all duration-300 border-b border-transparent group-hover:border-[#c9a961] pb-1" data-id="element-90">
                    Learn More{' '}
                    <ArrowRightIcon className="w-4 h-4 text-[#c9a961]" data-id="element-91" />
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}